<div class="p-3">
  <div
    class="surface-100 cursor-pointer z-index border-round"
    (click)="openModal()"
  >
    <div class="relative">
      <div class="relative w-full h-48 md:h-64 overflow-hidden flex items-center justify-center bg-gray-100 rounded-lg">
        <img
          [src]="news.image+news.imageToken"
          alt="Image de l'actualité"
          class="object-cover w-full h-full"
        />
      </div>
    </div>
    <div class="p-3">
      <div class="flex flex-col items-start mb-3">
        <div
          class="flex flex-wrap gap-2 mb-1"
          *ngIf="showMotsCles && news.motCles && news.motCles.length"
        >
          <span
            *ngFor="let motCle of news.motCles"
            class="bg-primary-100 text-primary-800 px-2 py-1 rounded-full text-xs font-semibold"
          >
            {{ motCle }}
          </span>
        </div>
        <div
          class="flex flex-wrap gap-2 mb-1"
          *ngIf="showMotCles && news.motCles && news.motCles.length"
        >
          <span
            *ngFor="let tag of news.motCles"
            class="bg-primary-100 text-primary-800 px-2 py-1 rounded-full text-xs font-semibold"
          >
            {{ tag }}
          </span>
        </div>
        <div class="text-900 font-semibold text-xl hover:underline w-full truncate">
          {{ news.titre }}
        </div>
      </div>
      <p
        class="text-700 text-lg mt-0 mb-5 tooltip-large w-full overflow-hidden text-ellipsis whitespace-nowrap"
        [pTooltip]="news.resume.length > 20 ? news.resume : undefined"
        tooltipPosition="top"
      >
        {{news.resume}}
      </p>

      <!-- META -->
      <div class="flex flex-wrap gap-2 align-items-center justify-between">
        <span class="flex items-center text-900">
          <i class="pi pi-user mr-2"></i>
          <span class="font-semibold">{{ news.auteur }}</span>
        </span>
        <span class="flex items-center text-900">
          <i class="pi pi-clock mr-2"></i>
          <span class="font-semibold mr-1">{{ news.jour }} </span>
          <span class="font-semibold">{{ news.mois }}</span>
        </span>
      </div>
    </div>
  </div>

  <p-dialog
    [(visible)]="displayModal"
    [modal]="true"
    [maximizable]="false"
    [closable]="true"
    [dismissableMask]="true"
    [baseZIndex]="10000"
    [style]="{
      width: '95vw',
      minHeight: '90vh',
      top: '5vh',
      left: '5vw',
      margin: '0',
      borderRadius: '1.5rem'
    }"
    [draggable]="false"
    [resizable]="false"
    (onHide)="closeModal()"
  >
    <app-news-details
      [news]="news"
      [showMotsCles]="showMotsCles"
      [showMotCles]="showMotCles"
    ></app-news-details>
  </p-dialog>
</div>
